import React from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const CellData = ({ data }) => {
  return (
    <div className={styles.cell} itemScope itemType='https://schema.org/Thing'>
      {!!data.left_icon && (
        <Image
          src={data?.left_icon}
          alt='left icon'
          title='left icon'
          loading='lazy'
          layout='fill'
        />
      )}

      <ul>
        <li>
          <div>
            {data.left_heading && (
              <div className={styles.title}>{data.left_heading}</div>
            )}
            {data.left_text && (
              <div className={styles.text}>{data.left_text}</div>
            )}
          </div>
          <div className={styles.right}>
            {data.right_heading && (
              <div className={styles.title}>{data.right_heading}</div>
            )}
            {data.right_text && (
              <div className={styles.text}>{data.right_text}</div>
            )}
          </div>
        </li>
      </ul>
      {!!data.icons &&
        data.icons.map((icon) => (
          <div className={styles.icon} key={''}>
            <Image
              src={icon}
              alt={'icon'}
              title='icon'
              loading='lazy'
              layout='fill'
            />
          </div>
        ))}
    </div>
  );
};

export default CellData;
